import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {ProfilePage} from "../../pages/profile/profile";
import {NavController} from "ionic-angular";
import {AccountProvider} from "../../providers/account/account";

/**
 * Generated class for the SidebarComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'sidebar',
    templateUrl: 'sidebar.html'
})
export class SidebarComponent implements OnDestroy{
    @Output() onClose = new EventEmitter();

    @Input() freeze = false;

    public users: any = [];
    public profile: any = {};
    public progress: any = 0;

    interval_loadProfile = null;

    constructor(public navCtrl: NavController,
                public accountProvider: AccountProvider) {
        console.log('Hello SidebarComponent Component');
        this.loadTops();

        this.loadProfile();
        this.interval_loadProfile = setInterval(() => {
            this.loadProfile();
        }, 30000);
    }

    ngOnDestroy() {
        clearInterval(this.interval_loadProfile);
    }

    close () {
        this.onClose.emit(true);
    }

    goProfile() {
        this.navCtrl.push(ProfilePage);
    }

    loadProfile() {
        this.accountProvider.loadProfile().subscribe((resp: any) => {
            this.profile = resp.data || {};
            resp.data.toku_level = resp.data.toku_level || 1;
        });
    }

    loadTops() {
        this.accountProvider.topTen({
            post_type: 'student',
            order_by: 'total_points',
            order_asc: 'desc',
            page: 1,
            ppp: 5
        }).subscribe((resp: any) => {
            this.users = resp.data || [];
        })
    }

}



// WEBPACK FOOTER //
// ./src/components/sidebar/sidebar.ts